module.exports = __webpack_public_path__ + "img/y2.b009aa2a.webp";